// this line installs the variable Breakpoints as a global - it is re-exported so that client modules do just access globals
const Breakpoints = require('js-breakpoints'); // eslint-disable-line no-unused-vars

export default window.Breakpoints;
